import makeSlice from '@web/slices/reward/sliceMaker'

const slice = makeSlice()

export default slice.reducer
